import * as React from 'react';
const RoundFilters = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={44}
    height={44}
    viewBox={'0 0 44 44'}
    fill='none'
    {...props}
  >
    <circle cx={22} cy={22} r={21.5} fill='#FAFDFF' stroke='#EFEFEF' />
    <g clipPath='url(#filtersa)' transform='translate(10.5 10.5)'>
      <g fill='#2772AF'>
        <path d='M22.04 18.447H19.42a3.572 3.572 0 0 0-6.895 0H.96a.958.958 0 1 0 0 1.917h11.565a3.572 3.572 0 0 0 6.895 0h2.622a.958.958 0 1 0 0-1.917ZM.96 12.458H3.58a3.571 3.571 0 0 0 6.894 0H22.04a.958.958 0 1 0 0-1.916H10.475a3.571 3.571 0 0 0-6.894 0H.96a.958.958 0 1 0 0 1.916ZM.96 4.553h11.564a3.572 3.572 0 0 0 6.895 0h2.622a.958.958 0 0 0 0-1.917h-2.622a3.572 3.572 0 0 0-6.895 0H.96a.958.958 0 1 0 0 1.917Z' />
      </g>
    </g>
    <defs>
      <clipPath id='filtersa'>
        <path fill='#fff' d='M23 23H0V0h23z' />
      </clipPath>
    </defs>
  </svg>
);
export default RoundFilters;
